import moment from 'moment'

const initialState =
 {  
    loading: false, 
    error:false,
    message:"",
    marcas:[],
    reportes:[],
    idReporte:null,
    idMarca:null,
    idUnidad:null,
    anio:null,
    mes:null,
    data:[],
    extraData:[],
    columnsData:[],
    csvName:"",
    csvData:[], fecha: moment()

 }

export default (state = initialState, action) => {
    switch (action.type) {
        case "RESET_REPORTS":
            return initialState;
       case "LOADING_REPORTS":
            return { ...state,loading:action.payload,error:false,message:""};
       case "ERROR_REPORTS":
            return { ...state,loading:false,error:true,message:action.payload};
       case "RESET_DATA_REPORTS":
            return { ...state,data:[],extraData:[]};
       case "READY_GLOBAL_DATA_REPORTS":
            return { ...state,loading:false,error:false,message:"",
                    marcas:action.payload.marcas,reportes:action.payload.reportes};
        case "READY_DATA_REPORTS":
            return { ...state,loading:false,error:false,message:"",
                    data:action.payload.data,columnsData:action.payload.columnas,extraData:action.payload.extraData};
       case "ERROR_TOKEN_REPORTS":
            return { ...state,loading:false,error:true,message:action.payload};
       case "CHANGE_FILTER_REPORTS":
            return { ...state,...action.payload};
       case "READY_CSV_DATA_REPORTS":
            return { ...state,loading:false,error:false,message:"",
                    csvName:action.payload.name,csvData:action.payload.data};
       default:
    }
    return state;
}
